import { AnalysisSetting } from '~/packages/variable/variables.typing'
import object, { ObjectType, ShapeBase } from '../object'

// @TODO: Implement analysis type
export const analysis = object<AnalysisSetting & ShapeBase>(
  {} as AnalysisSetting & ShapeBase,
).isOptional()
